import { useEffect } from "react";
import AboutSelfieCollage from "../components/about/AboutSelfieCollage";
import PageMeta from "../components/seo/PageMeta";
import {
  ABOUT_HERO,
  ABOUT_IMAGES,
  ABOUT_META,
  ABOUT_PROSE,
} from "../data/aboutContent";
import { uploadUrl } from "../lib/assets";
import { buildPersonJsonLd, buildWebPageJsonLd } from "../lib/seo";
import "../styles/about.css";

export default function AboutPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const heroImage = uploadUrl(ABOUT_HERO.imageKey);
  const breakImage = uploadUrl(ABOUT_IMAGES.break);
  const wildlifeLeft = uploadUrl(ABOUT_IMAGES.wildlifeLeft);
  const wildlifeRight = uploadUrl(ABOUT_IMAGES.wildlifeRight);

  return (
    <article className="about-page" aria-label="About">
      <PageMeta
        title={ABOUT_META.title}
        description={ABOUT_META.description}
        path={ABOUT_META.path}
        image={ABOUT_META.imageKey}
        type="profile"
        keywords={[
          "CJ Jayamaha",
          "about",
          "photographer biography",
          "storyteller",
          "product leader",
        ]}
        jsonLd={[
          buildPersonJsonLd(),
          buildWebPageJsonLd({
            title: ABOUT_META.title,
            description:
              "Product leader, photographer, filmmaker, adventurer and storyteller behind cj.photos.",
            path: ABOUT_META.path,
            image: ABOUT_META.imageKey,
          }),
        ]}
      />
      <header className="about-hero">
        <div
          className="about-hero__image"
          style={{ backgroundImage: `url('${heroImage}')` }}
        />
        <div className="about-hero__scrim" />
        <div className="about-hero__content">
          <div className="about-hero__eyebrow">{ABOUT_HERO.eyebrow}</div>
          <h1 className="about-hero__title">{ABOUT_HERO.title}</h1>
        </div>
      </header>

      <div className="about-prose about-prose--opening">
        <p className="about-prose__lead">{ABOUT_PROSE.openingLead}</p>
        <p className="about-prose__statement">{ABOUT_PROSE.openingStatement}</p>
      </div>

      <div className="about-prose">
        <p className="about-prose__body">{ABOUT_PROSE.exploration}</p>
        <p className="about-prose__body about-prose__body--ink">{ABOUT_PROSE.photographyLine}</p>
      </div>

      <figure className="about-break">
        <div className="about-break__frame">
          <div
            className="about-break__image"
            style={{ backgroundImage: `url('${breakImage}')` }}
          />
          <div className="about-break__scrim" />
          <figcaption className="about-break__caption">
            <span>{ABOUT_PROSE.breakCaption}</span>
          </figcaption>
        </div>
      </figure>

      <div className="about-prose about-prose--after-break">
        <p className="about-prose__body">{ABOUT_PROSE.afterBreak}</p>
      </div>

      <div className="about-wildlife">
        <div className="about-wildlife__grid">
          <div
            className="about-wildlife__tile"
            style={{ backgroundImage: `url('${wildlifeLeft}')` }}
            role="img"
            aria-label="Wildlife photograph"
          />
          <div
            className="about-wildlife__tile"
            style={{ backgroundImage: `url('${wildlifeRight}')` }}
            role="img"
            aria-label="Rhino photograph"
          />
        </div>
      </div>

      <div className="about-prose about-prose--closing">
        <p className="about-prose__body about-prose__body--spaced">{ABOUT_PROSE.websiteIntro}</p>
        <blockquote className="about-quote">
          <p>{ABOUT_PROSE.quote}</p>
        </blockquote>
        <p className="about-prose__body about-prose__body--after-quote">{ABOUT_PROSE.closing}</p>
      </div>

      <section className="about-selfies" aria-labelledby="about-selfies-heading">
        <div className="about-selfies__header">
          <p className="about-selfies__eyebrow">OVER THE YEARS</p>
          <h2 id="about-selfies-heading" className="about-selfies__title">
            Selfies over the years
          </h2>
        </div>
        <AboutSelfieCollage />
      </section>
    </article>
  );
}
